module.exports = __webpack_public_path__ + "img/other_realme2.0977d88c.jpg";